import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import GallectionListItemButton from '../../../GallectionListItem/GallectionListItemButton';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import { FolderType } from '../../redux/types';
import s from './FolderList.scss';
const FolderList = ({ submissionType , folders , isFetching , streamId , hasOnlyOneChunkOfGroupFoldersToLoad , onFolderSelected  })=>{
    const { t  } = useTranslation();
    const [filterValue, setFilterValue] = useState('');
    const hasNoFolders = !isFetching && !folders.length;
    const [justAddedToFolderIds, setAddedToFolderIds] = useState([]);
    const onGallectionListItemClick = ({ folderId  })=>{
        onFolderSelected(folderId);
        setAddedToFolderIds([
            ...justAddedToFolderIds,
            folderId
        ]);
    };
    const { setTrackingRef: setInputRef  } = useBiClickLogger(BiData({
        evid: 2,
        click_info: submissionType === FolderType.Collection ? 'addToGroup.searchCollection' : 'addToGroup.searchGallery',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue
    }));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, hasOnlyOneChunkOfGroupFoldersToLoad && /*#__PURE__*/ React.createElement(TextInput, {
        id: "add-to-group-filter-input",
        ref: setInputRef,
        value: filterValue,
        className: s['filter-input'],
        onChange: (ev)=>setFilterValue(ev.target.value),
        placeholder: t('addToGroupPopup.input.filter.placeholder'),
        prefix: /*#__PURE__*/ React.createElement(SearchIcon, null),
        label: t('addToGroupPopup.input.filter.placeholder'),
        isLabelHidden: true
    }), /*#__PURE__*/ React.createElement(StreamedList, {
        streamId: streamId,
        className: s['list'],
        wrapperClassName: s['scrollable']
    }, folders.map(({ folder , added , suggested  })=>{
        if (!folder || filterValue && !folder.name.toLowerCase().includes(filterValue.toLowerCase())) {
            return null;
        }
        const renderSuffix = ()=>{
            let buttonI18nKey = 'addToGroupPopup.button.add';
            if (added) {
                buttonI18nKey = 'addToGroupPopup.button.added';
            }
            if (suggested) {
                buttonI18nKey = 'addToGroupPopup.button.suggested';
            }
            return /*#__PURE__*/ React.createElement(TextButton, {
                size: "small",
                variant: "approval-green",
                disabled: added || suggested
            }, t(buttonI18nKey));
        };
        return /*#__PURE__*/ React.createElement(GallectionListItemButton, {
            key: folder.folderId,
            checked: added || suggested || justAddedToFolderIds.includes(folder.folderId),
            disabled: added || suggested,
            gallection: folder,
            showSuffixOnlyOnHover: !added && !suggested,
            suffix: renderSuffix(),
            onClick: ()=>onGallectionListItemClick(folder)
        });
    }), hasNoFolders && /*#__PURE__*/ React.createElement("div", {
        className: s['empty']
    }, t(`addToGroup.noFolders.${submissionType}`))), isFetching && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['loader']
    }));
};
FolderList.displayName = 'FolderList';
export default FolderList;
